import repository from "../Repository";

export default {
  async list(screenId, municipality, disasterNo) {
    return repository.post(
      `vul_facility_status_info`,
      {
        municip_code: municipality,
        disaster_no: disasterNo
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async update(screenId, payload) {
    return await repository.patch(`vul_facility_status_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
